import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
// import BlogCard from "./BlogsCards";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import leaf from "../../Assets/Projects/dcube.png";
// import emotion from "../../Assets/Projects/emotion.jpeg";
import editor from "../../Assets/Projects/smarttravel.jpeg";
// import eeg from "../../Assets/Projects/eeg.gif";
import suicide from "../../Assets/Projects/prince.jpeg";
import eshop from "../../Assets/Projects/eshop.PNG";
import protainer from "../../Assets/Projects/protainer.PNG";
import smarttravel from "../../Assets/Projects/smarttravel.PNG";
import ecom from "../../Assets/Projects/ecom.PNG";
import sastabazar from "../../Assets/Projects/sastabazar.PNG";
// import algo from "../../Assets/Projects/algo.png";
// import plant from "../../Assets/Projects/plant.jpeg";


import chatapp from "../../Assets/Projects/chat-app.PNG";
import youtubeclone from "../../Assets/Projects/youtube-clone-app.PNG";
import airbnbclone from "../../Assets/Projects/airbnb-clone-app.PNG";
import covidapp from "../../Assets/Projects/covid-app.PNG";
import hrm from "../../Assets/Projects/hrm.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Work </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects that I've worked on.
        </p>



<br></br>
        <h3 style={{ color: "white" }}>
          Android Projects
        </h3>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="D-Cube (Data Driven Driving) "
              description="Developed a project called D-Cube (Data Driven Driving) as my FYP which provides car owners a monitoring system through which they will be able to monitor their drivers driving behavior."
              link="https://github.com/Sameer18-Dev/DataDrivenDriving"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Prince-App"
              description="Developed a project for Prince Corporation in which a MVP was created that automated their provisional sales order and also provides users their previous order history."
              link="https://github.com/Sameer18-Dev/Prince-App"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Smart Travel Guide"
              description="The main objective of this application is when the users are on the move, it will be able to provide rich and concise information timely and make them accessible to the service at any time and anywhere."
              link="https://github.com/Sameer18-Dev/SmartTravelGuide"
            />
          </Col>
        </Row>


        <br></br>
        <h3 style={{ color: "white" }}>
          Laravel Projects
        </h3>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={smarttravel}
              isBlog={false}
              title="SmartTravel"
              description="Developed a project called SmartTravel that provides various facilities like transport service, restaurant booking, food ordering, and also accommodates for hotels, resorts etc."
              link="https://footless-breakdown.000webhostapp.com"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eshop}
              isBlog={false}
              title="Eshop"
              description="Developed an ecommerce site called Eshop that provide various products based on different categories, user can add items to their cart and proceed to checkout after providing their credentials and credit card info."
              link="http://eshop.42web.io"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={protainer}
              isBlog={false}
              title="Pro-tainer"
              description="Pro-tainer has been manufacturing trailers since 1990. Pro-Tainer provides huge variety of products that are authentic and all are federally approved available on DOD and GSA contracts."
              link="https://protainer.com"
            />
          </Col>
        </Row>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sastabazar}
              isBlog={false}
              title="Sastabazar"
              description="Sastabazar is an Indian online grocery store. With huge variety of products and various brands in our catalogue you will find everything you are looking for - we have it all. You can pay online using your credit card or by cash on delivery."
              link="https://www.sastabazar.co"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hrm}
              isBlog={false}
              title="HRM"
              description="Developed a (HRM) Human Resource Management system that manages all the employees of an organization. This system includes various modules that helps maintain employee records such as there profile, department, attendance, salary and much more."
              link="https://wavetec-hrm.herokuapp.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ecom}
              isBlog={false}
              title="Ecom"
              description="Developed an ecommerce site called Ecom that provide various products based on different categories, user can add items to their cart and proceed to checkout after providing their credentials and credit card information."
              link="http://laravel-ecom-demo.herokuapp.com"
            />
          </Col>
        </Row>

        <br></br>
        <h3 style={{ color: "white" }}>
          React Projects
        </h3>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={covidapp}
              isBlog={false}
              title="Covid-Stats"
              description="Developed an app called Covid-Stats that shows realtime covid stats world wide as well as country wise also, 3rd party api has been used in this app that provides updated country data wise, user can also select specific country from the dropdown to view it's record."
              link="https://my-covid-stats-app.herokuapp.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatapp}
              isBlog={false}
              title="Chat-App"
              description="Developed an app called Chat-App that contains different chat rooms where users can send messages/media with other users and also can see other users status active/in-active, use these test credentials name admin & pwd admin for login."
              link="https://chat-app-demo.netlify.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={youtubeclone}
              isBlog={false}
              title="Youtube-Clone"
              description="Developed an app called Youtube-Clone that mimics most of the youtubes functionalities which includes trending videos, video search, video playback and much more. This app uses Youtube Data API for pulling the videos that are visible to the users."
              link="https://youtubeclone-demo.netlify.app"
            />
          </Col>
        </Row>


        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={airbnbclone}
              isBlog={false}
              title="Airbnb-Clone"
              description="Developed an app called Airbnb-Clone that includes most of the functionalities that Airbnb website consists including the advance apartment search. This app does not pull the data from the airbnb API however this will be implmented soon in the next update."
              link="https://youtubeclone-demo.netlify.app"
            />
          </Col>
        </Row>


      </Container>
    </Container>
  );
}

export default Projects;
